import { useState } from "react";

// Components
import CiRelationTypesDataGrid from "./CiRelationTypesDataGrid";
import CiRelationTypeDeleteDialog from "./CiRelationTypeDeleteDialog";
import CiRelationTypeDrawer from "./CiRelationTypeDrawer";
import CiRelationTypesToolbar from "./CiRelationTypesToolbar";

import { SelectedCiRelationTypesContext } from "../context/SelectedCiRelationTypesContext";

function CiRelationTypes() {
  const [isCreatorOpen, setIsCreatorOpen] = useState(false);
  const [isEditorOpen, setIsEditorOpen] = useState(false);
  const [isRemoverOpen, setIsRemoverOpen] = useState(false);

  return (
    <SelectedCiRelationTypesContext>
      <CiRelationTypesToolbar
        setIsAddOpen={setIsCreatorOpen}
        setIsEditOpen={setIsEditorOpen}
        setIsRemoverOpen={setIsRemoverOpen}
      />
      <div style={{ flex: 1, overflowY: "auto" }}>
        <CiRelationTypesDataGrid />
      </div>
      <CiRelationTypeDrawer isOpen={isCreatorOpen} setIsOpen={setIsCreatorOpen} newItem={true} />
      <CiRelationTypeDrawer isOpen={isEditorOpen} setIsOpen={setIsEditorOpen} />
      {isRemoverOpen && <CiRelationTypeDeleteDialog isOpen={isRemoverOpen} setIsOpen={setIsRemoverOpen} />}
    </SelectedCiRelationTypesContext>
  );
}

export default CiRelationTypes;
